import { extractYoutubeVideoId, normalizeYoutubeWatchUrl } from './youtubeLink'

const BUNNY_EMBED_RE = /iframe\.mediadelivery\.net\/embed\/(\d+)\/([a-f0-9-]+)/i
const BUNNY_PLAY_IFRAME_RE = /iframe\.mediadelivery\.net\/play\/(\d+)\/([a-f0-9-]+)/i
const BUNNY_PLAY_RE = /video\.bunnycdn\.com\/play\/(\d+)\/([a-f0-9-]+)/i

/**
 * Extrai URL de iframe HTML ou texto puro.
 * @param {string} text
 */
export function extractVideoInputUrl(text) {
  if (!text) return ''
  const trimmed = String(text).trim()
  const iframeMatch = trimmed.match(/<iframe[^>]+src=["']([^"']+)["']/i)
  if (iframeMatch) return iframeMatch[1].trim()
  return trimmed
}

/**
 * @param {string} url
 * @returns {string|null} URL embed normalizada do Bunny Stream
 */
export function extractBunnyEmbedUrl(url) {
  const input = extractVideoInputUrl(url)
  if (!input) return null

  const candidates = [input]
  if (!/^https?:\/\//i.test(input)) {
    candidates.push(`https://${input}`)
  }

  for (const candidate of candidates) {
    let match = candidate.match(BUNNY_EMBED_RE)
    if (match) {
      return `https://iframe.mediadelivery.net/embed/${match[1]}/${match[2]}`
    }
    match = candidate.match(BUNNY_PLAY_IFRAME_RE)
    if (match) {
      return `https://iframe.mediadelivery.net/embed/${match[1]}/${match[2]}`
    }
    match = candidate.match(BUNNY_PLAY_RE)
    if (match) {
      return `https://iframe.mediadelivery.net/embed/${match[1]}/${match[2]}`
    }
  }

  return null
}

/**
 * @param {string} url
 * @returns {'youtube'|'bunny'|null}
 */
export function getLessonVideoProvider(url) {
  const input = extractVideoInputUrl(url)
  if (extractYoutubeVideoId(input)) return 'youtube'
  if (extractBunnyEmbedUrl(input)) return 'bunny'
  return null
}

/**
 * @param {string} url
 */
export function isValidLessonVideoUrl(url) {
  return getLessonVideoProvider(url) != null
}

/**
 * Normaliza URL para persistência (YouTube watch ou Bunny embed).
 * @param {string} url
 * @returns {string|null}
 */
export function normalizeLessonVideoUrl(url) {
  const input = extractVideoInputUrl(url)
  const ytId = extractYoutubeVideoId(input)
  if (ytId) return normalizeYoutubeWatchUrl(ytId)
  return extractBunnyEmbedUrl(input)
}
